import ApiService, { HTTPMethod } from './api.core'
import { FirebaseService, FirebaseConfigKey } from '../services/FirebaseService'
class ReportsApi {
  async sendBorderauxToGlobal(date, transferNumber) {
    return ApiService.fetch(
      `reports/MonthlyBorderaux?month=${date}&transferNumber=${transferNumber}`,
      HTTPMethod.POST
    )
  }
  async getBorderauxToGlobalData(date, transferNumber) {
    return await ApiService.fetch(
      `reports/MonthlyBorderaux?month=${date}&transferNumber=${transferNumber}`,
      HTTPMethod.GET
    )
  }
}
export default new ReportsApi()
